import { Controller } from '@hotwired/stimulus'

// Chrome-less inline editing (list section titles): the field looks like the title it replaces.
// Enter submits (the form's native submit), losing focus saves when the text changed, Esc reverts.
//
// Esc is swallowed (:stop in the markup): otherwise it would bubble up to the Terminer button's
// keydown.esc@window and leave organize mode with the field still open.
export default class extends Controller {
  static targets = ['input', 'mirror']

  // Enter: the submit is on its way — the focusout that follows must not race it.
  submit() {
    this.submitting = true
  }

  // Only saves when the text really changed (blank reverts rather than posting a validation error).
  save() {
    if (this.submitting || !this.hasInputTarget) return

    const input = this.inputTarget
    if (input.value.trim() === '') return this.revert()
    if (input.value !== input.defaultValue) input.form.requestSubmit()
  }

  // Back to the stored name, without a request — the blur that follows then finds no change.
  revert() {
    if (!this.hasInputTarget) return

    this.inputTarget.value = this.inputTarget.defaultValue
    this.resize()
    this.inputTarget.blur()
  }

  // "grow-wrap" sizing: the invisible mirror (same grid cell, same styles) carries the current text
  // — the cell hugs its width and the field (w-full) fills it. The rule then sits right against the
  // title.
  resize() {
    if (!this.hasMirrorTarget || !this.hasInputTarget) return

    this.mirrorTarget.textContent = this.inputTarget.value
  }
}
